import { useTranslation } from "react-i18next";
import { Button, Icon, Modal } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import "modules/AppointmentDetails/components/PonOvis/components/PONOvisModal/PONOvisModal.scss";
import { formatDate } from "utils/dateHelperFunctions";

import type { PonOvisEvent } from "modules/AppointmentDetails/components";

type PONOvisModalProps = {
  events?: PonOvisEvent[];
  isOpen: boolean;
  onClose: () => void;
  onGoToNextPage: () => void;
  onGoToPreviousPage: () => void;
  page: number;
};

const fieldLabelMap: ReadonlyMap<string, string> = new Map<keyof PonOvisEvent, string>([
  ["masterDataSource", "v8_data_source"],
  ["commissionYear", "v8_commission_year"],
  ["commissionNumber", "v8_commission_number"],
  ["vin", "v8_vin_nr"],
  ["shortVin", "v8_short_vin"],
  ["licensePlate", "v8_license_plate"],
  ["eventTypeCode", "v8_event_type_code"],
  ["eventTypeEN", "v8_event_type"],
  ["eventTypeNL", "v8_event_type_nl"],
  ["eventStatusCode", "v8_event_status_code"],
  ["eventStatus", "v8_event_status"],
  ["eventSequence", "v8_event_sequence"],
  ["eventDate", "v8_event_date"],
  ["info", "v8_pon_info"],
  ["created", "v8_created_on"],
  ["modified", "v8_modified_on"]
]);

const formatValue = (key: string, value: string) => {
  if (key === "eventDate" || key === "created" || key === "modified") return formatDate(value, DATE_FORMATS_FNS.dateMonthYearTime);

  return value;
};

export const PONOvisModal = ({ events, isOpen, onClose, onGoToNextPage, onGoToPreviousPage, page }: PONOvisModalProps) => {
  const { t } = useTranslation();

  const event = events && events.length >= page ? events[page - 1] : null;

  return (
    <Modal open={isOpen} onClose={onClose} className="ovis-modal">
      <Modal.Header>
        {t("v8_ovis_info", "OVIS Info")}

        <Button className="modal-close-btn" basic onClick={onClose}>
          <Icon className="xmark" />
        </Button>
      </Modal.Header>
      <Modal.Content>
        {events && event ? (
          <div className="PONOvisEvent">
            {Object.entries(event).map(([key, value]) => {
              const label = fieldLabelMap.get(key);
              if (!value || !label) return null;

              return (
                <div className="data-row" key={key}>
                  <div className="label">{t(label, label)}</div>
                  <div className="value">{formatValue(key, value)}</div>
                </div>
              );
            })}

            <div className="nav-controls">
              <Button disabled={page === 1} onClick={onGoToPreviousPage} className="nav-button prev">
                <Icon className="angle left" />
              </Button>
              <Button disabled={page >= events.length} onClick={onGoToNextPage} className="nav-button next">
                <Icon className="angle right" />
              </Button>
            </div>
          </div>
        ) : (
          <div className="no-data">{t("v8_no_data_found", "No data found")}</div>
        )}
      </Modal.Content>
    </Modal>
  );
};
